const FloorV1TokenMerkleClaimAbi = [
  {
    inputs: [
      { internalType: 'bytes32', name: '_root', type: 'bytes32' },
      { internalType: 'contract IERC20', name: '_token', type: 'address' },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  { inputs: [], name: 'InvalidMerkleProof', type: 'error' },
  { inputs: [], name: 'RecipientAlreadyClaimed', type: 'error' },
  {
    inputs: [{ internalType: 'address', name: '_recipient', type: 'address' }],
    name: 'claimed',
    outputs: [{ internalType: 'bool', name: '_claimed', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_recipient', type: 'address' },
      { internalType: 'uint256', name: '_amount', type: 'uint256' },
    ],
    name: 'leaf',
    outputs: [{ internalType: 'bytes32', name: 'leaf_', type: 'bytes32' }],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [],
    name: 'root',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'token',
    outputs: [{ internalType: 'contract IERC20', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes32[]', name: '_proof', type: 'bytes32[]' },
      { internalType: 'address', name: '_recipient', type: 'address' },
      { internalType: 'uint256', name: '_amount', type: 'uint256' },
    ],
    name: 'verify',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;

export default FloorV1TokenMerkleClaimAbi;
